module.exports = __webpack_public_path__ + "static/logo-c46ece5c092a1e3f111885f21f9dceb6.png";